import { useEffect, useState } from 'react';
import { FetchAreas, FetchKnowledgeChart, FetchTags } from '../../services/Charts.js';
import './index.css';
import Cookies from 'js-cookie';
import reportIcon from '../../Assets/carbon_report.png';

import { 
    BarChart, 
    Bar, 
    XAxis, 
    YAxis, 
    Tooltip, 
    ResponsiveContainer, 
    Cell, 
    CartesianGrid,
    PieChart,
    Pie,
    Legend
} from "recharts";

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { useRef } from 'react';

function KnowledgeTestChart(){

    const [error, setError] = useState('');
    const [chartData, setChartData] = useState([]);
    const [tags, setTags] = useState();
    const chartRef = useRef(null);

    const retrieveTags=async ()=>{
        const response=await FetchAreas();
        console.log('tags',response);
        setTags(response.data);
    } 
    const colors = ['#118693', '#82ca9d', '#ffc658', '#ff7300', '#d45087']; 

    const findTags = async () => {
        const response = await FetchKnowledgeChart(Cookies.get('id'));
        if (response.success) {

            console.log('res', response);

            const formattedData = response.data.map((item, index) => ({
               tag: tags?.find(e => e.id === Number(item._id))?.name,
                percentage: (item.correctAnswers / item.totalQuestions) * 100, 
                color: colors[index % colors.length] 
            }));

            setChartData(formattedData);
            return;
        }
        console.log('response',response);
        setError(response.message);
    };

    const downloadPDF = () => {
        if (!chartRef.current) return;
        html2canvas(chartRef.current, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({
                orientation: "landscape",
                unit: "pt",
                format: [canvas.width, canvas.height],
            });
            pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);
            pdf.save('psychometric_chart.pdf');
        });
    };


    useEffect(() => { findTags() }, [tags]);
    useEffect(() => { retrieveTags() }, []);

 return (
    <>
                          {chartData.every(item => item.percentage === 0) ? (
   <div style={{ textAlign: 'center', padding: '40px',height:"50px",overflow:"hidden" }}>
                          <h2 style={{ textAlign: 'center', marginBottom: '10px',height:"50px" , fontSize:"20px", fontWeight:"600"}}>Knowledge Test Chart</h2>
        <p style={{height:"100%"}}>No data available yet.</p>
    </div>
) :( 
      <div className='chart-container' ref={chartRef} style={{ background: '#fff', padding: '20px'}}>
          <h2 style={{ textAlign: 'center', marginBottom: '40px', height:"50px" }}> Knowledge Test Chart</h2>
        
        {/* Bar Chart */}
        <ResponsiveContainer width="90%" height={300}>  {/* Fixed height instead of 100% */}
            <BarChart data={chartData} layout="vertical" margin={{ top: 10, right: 30, left: 20, bottom: 10 }} barSize={40}>
                <XAxis type="number" domain={[0, 100]} tickCount={11} tick={{ fontSize: 14 }} />
                <YAxis dataKey="tag" type="category" width={150} tick={{ fontSize: 14 }} />
                <Tooltip formatter={(value) => `${value.toFixed(2)}%`} />
                <Bar dataKey="percentage" radius={[0, 8, 8, 0]}>
                    {chartData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                </Bar>
            </BarChart>
        </ResponsiveContainer>

    <div style={{ width: '90%', marginTop: '60px', display: 'flex',  overflow: 'visible',flexDirection: 'column', alignItems: 'center',marginTop:'180px' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '40px',height:"40px" }}>Distribution by Tag</h2>
        <div style={{ width: '100%', height: '600px', display: 'flex', justifyContent: 'center', overflow: 'hidden', }}>
            <ResponsiveContainer width="80%" height="100%" style={{overflow:"auto"}}>
                <PieChart>
                    <Pie
                        data={chartData}
                        cx="50%"
                        cy="45%"
                        labelLine={true}
                        label={(entry) => `${entry.percentage.toFixed(1)}%`}
                        outerRadius={100}
                        dataKey="percentage"
                    >
                        {chartData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} style={{ height:"70px" }}/>
                        ))}
                    </Pie>
                    <Tooltip formatter={(value) => `${value.toFixed(2)}%`} />
                    <Legend 
                        verticalAlign="bottom"
                        height={38}
                        formatter={(value, entry) => entry.payload.tag} 

                    />
                </PieChart>
            </ResponsiveContainer>
        </div>
    </div>

    </div>)}
    </>
);
}

export default KnowledgeTestChart;